import * as actionTypes from './types';
import { request } from '../../request/index';

export const crmSettings = {
    resetState:
        (props = {}) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_RESET_STATE,
                });
            },
    resetAction:
        ({ actionType }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_RESET_ACTION,
                    keyState: actionType,
                    payload: null,
                });
            },
    currentItem:
        ({ data }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_CURRENT_ITEM,
                    payload: { ...data },
                });
            },
    currentAction:
        ({ actionType, data }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_CURRENT_ACTION,
                    keyState: actionType,
                    payload: { ...data },
                });
            },
    list:
        ({ url, jsonData, entity, options }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'list',
                    payload: null,
                });

                let data = await request.list({ url, jsonData, entity, options });

                if (data?.status === 200) {
                    const result = {
                        items: data?.data?.Records,
                        pagination:
                            data?.data?.Pagination,
                    };

                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'list',
                        payload: result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'list',
                        payload: null,
                    });
                }
            },
    query:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'query',
                    payload: null,
                });

                let data = await request.query({ url, jsonData, entity });

                if (data?.status === 200) {
                    const result = {
                        items: data?.data?.Records[0],
                        // pagination:
                        // {
                        //     current: parseInt(data.pagination.page, 10),
                        //     pageSize: parseInt(data.pagination.pages, 10),
                        //     showSizeChanger: false,
                        //     total: parseInt(data.pagination.count, 10),
                        // },
                    };
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'query',
                        payload: result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'query',
                        payload: null,
                    });
                }
            },
    // filter:
    //     ({ entity, options = { page: 1 } }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
    //                 keyState: 'filter',
    //                 payload: null,
    //             });

    //             let data = await request.filter({ entity, options });

    //             if (data.success === true) {
    //                 const result = {
    //                     items: data.result,
    //                     pagination: {
    //                         current: parseInt(data.pagination.page, 10),
    //                         pageSize: 10,
    //                         showSizeChanger: false,
    //                         total: parseInt(data.pagination.count, 10),
    //                     },
    //                 };
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
    //                     keyState: 'filter',
    //                     payload: result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
    //                     keyState: 'filter',
    //                     payload: null,
    //                 });
    //             }
    //         },
    // count:
    //     ({ entity, options = { page: 1 } }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
    //                 keyState: 'count',
    //                 payload: null,
    //             });

    //             let data = await request.count({ entity, options });

    //             if (data.success === true) {
    //                 const result = {
    //                     items: data.result,
    //                     pagination: {
    //                         current: parseInt(data.pagination.page, 10),
    //                         pageSize: 10,
    //                         showSizeChanger: false,
    //                         total: parseInt(data.pagination.count, 10),
    //                     },
    //                 };
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
    //                     keyState: 'count',
    //                     payload: result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
    //                     keyState: 'list',
    //                     payload: null,
    //                 });
    //             }
    //         },
    create:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'create',
                    payload: null,
                });

                let data = await request.create({ url, jsonData, entity });

                if (data.success === true) {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'create',
                        payload: data.result,
                    });

                    dispatch({
                        type: actionTypes.CRM_SETTINGS_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'create',
                        payload: null,
                    });
                }
            },
    read:
        ({ url, entity }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'read',
                    payload: null,
                });

                let data = await request.read({ url, entity });

                if (data.success === true) {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_CURRENT_ITEM,
                        payload: data.result,
                    });
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'read',
                        payload: data.result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'read',
                        payload: null,
                    });
                }
            },
    update:
        ({ url, jsonData, entity }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'update',
                    payload: null,
                });

                let data = await request.update({ url, jsonData, entity });

                if (data.success === true) {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'update',
                        payload: data.result,
                    });
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'update',
                        payload: null,
                    });
                }
            },

    delete:
        ({ url, jsonData, entity }: any) =>

            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'delete',
                    payload: null,
                });

                let data = await request.delete({ url, jsonData, entity });

                if (data.success === 200) {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'delete',
                        payload: data.result,
                    });
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_CURRENT_ITEM,
                        payload: data.result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'delete',
                        payload: null,
                    });
                }
            },
    summary:
        ({ url, jsonData, entity, options }: any) =>
            async (dispatch: any) => {
                dispatch({
                    type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
                    keyState: 'summary',
                    payload: null,
                });

                let data = await request.summary({ url, jsonData, entity, options });

                if (data?.status === 200) {
                    const result = {
                        items: data?.data,

                    };
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
                        keyState: 'summary',
                        payload: result,
                    });
                } else {
                    dispatch({
                        type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
                        keyState: 'summary',
                        payload: null,
                    });
                }
            },
    // search:
    //     ({ entity, options = {} }: any) =>
    //         async (dispatch: any) => {
    //             dispatch({
    //                 type: actionTypes.CRM_SETTINGS_REQUEST_LOADING,
    //                 keyState: 'search',
    //                 payload: null,
    //             });

    //             let data = await request.search({ entity, options });

    //             if (data.success === true) {
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_SUCCESS,
    //                     keyState: 'search',
    //                     payload: data.result,
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: actionTypes.CRM_SETTINGS_REQUEST_FAILED,
    //                     keyState: 'search',
    //                     payload: null,
    //                 });
    //             }
    //         },
};